<template>
	<div class="view-student">
		<Modal
			:show="showStudentFeeStructures"
			content_class="col-12 col-lg-8 col-xl-7 confirm-modal"
		>
			<template
				slot="content"
				v-if="
					selected_student_fee_structures &&
					selected_student &&
					selected_student_fee_structures.fee_structure_details
				"
			>
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Fee Structures for:
								{{
									selected_student.student_details
										.student_name
								}}
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit('showStudentFeeStructures', false)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div
									class="card fee-card student"
									@click="
										processFeeStructure(
											selected_student_fee_structures,
										)
									"
								>
									<div class="clearfix">
										<div
											class="f-r status tx-green"
											:class="{
												'tx-yellow':
													selected_student_fee_structures.status !==
													'ACTIVE',
											}"
										>
											{{
												selected_student_fee_structures.status
											}}
										</div>
									</div>

									<div class="ref">
										{{
											selected_student_fee_structures
												.fee_structure_details
												.fee_structure_system_ref
										}}
									</div>
									<div class="class">
										{{
											selected_student_fee_structures
												.fee_structure_details
												.fee_structure_name
										}}
									</div>
									<div class="time">
										Fee structure Period:
										<span class="date"
											>{{
												moment(
													selected_student_fee_structures
														.fee_structure_details
														.validity_start_date,
												).format('Do MMM YYYY')
											}}
											-
											{{
												moment(
													selected_student_fee_structures
														.fee_structure_details
														.validity_end_date,
												).format('Do MMM YYYY')
											}}</span
										>
									</div>
									<div class="total">
										{{
											selected_student_fee_structures.currency
										}}
										{{
											utils.numberWithCommas(
												selected_student_fee_structures.total,
											)
										}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
	},
	computed: {
		...mapGetters([
			'loading',
			'selected_student',
			'selected_student_fee_structures',
			'showStudentFeeStructures',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['processFeeStructure']),
	},
	mounted() {},
};
</script>

<style lang="less">
.view-student {
	.total.final {
		color: var(--ne-green) !important;

		&.tx-yellow {
			color: var(--ne-yellow) !important;
		}
	}
}
</style>
